// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"a4e2a77a","141":"a9631492","217":"93b40ae5","565":"b8b1e719","720":"0ef1219d","740":"11e8ea46","773":"789913a6","849":"6749a82d","867":"48e156da","883":"f7c7c482","890":"ded42b57","937":"c9d249a0","964":"047c16b9"}[chunkId] + ".chunk.js";
};